import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoStop = () => {
  return (
    <g>
      <path d="m14.49.0464h-12.98a.75.75 0 0 0 -.75.75v14.4072a.75.75 0 0 0 .75.75h12.98a.75.75 0 0 0 .75-.75v-14.4072a.75.75 0 0 0 -.75-.75zm-.75 14.4072h-11.48v-12.9072h11.48z" />
    </g>
  );
};

export default withIcon(IconVideoStop);
